import { render, staticRenderFns } from "./admin-inspection-table.vue?vue&type=template&id=1b7d1796&lang=html"
import script from "./admin-inspection-table.vue?vue&type=script&lang=js"
export * from "./admin-inspection-table.vue?vue&type=script&lang=js"
import style0 from "./admin-inspection-table.vue?vue&type=style&index=0&id=1b7d1796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports